import { Headline1, Meta, theme } from 'aimo-ui';
import React, { ReactNode } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';

type InfoBoxProps = {
  bgColor?: string;
  headline?: string;
  text?: string;
  padding?: number;
  radius?: number;
  margin?: number;
  children?: React.ReactNode;
  testID?: string;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
  boxAlign?: 'center' | 'flex-start';
  textCenter?: boolean;
  textColor?: string;
};
const Box = styled.View<{
  bgColor: string;
  padding: number;
  radius: number;
  margin: number;
  flexRow: boolean;
  boxAlign: 'center' | 'flex-start';
}>`
  background-color: ${({ bgColor }) => bgColor};
  padding: ${({ padding }) => `${padding}px`};
  border-radius: ${({ radius }) => `${radius}px`};
  margin: ${({ margin }) => ` 0 0 ${margin}px 0`};
  align-items: ${({ boxAlign }) => boxAlign};
  flex-direction: ${(p) => (p.flexRow ? 'row' : 'column')};
`;

const InfoBox = ({
  bgColor = theme.colors.gray100,
  headline = '',
  text = '',
  padding = 33,
  margin = 30,
  radius = 20,
  children,
  testID,
  leftComponent,
  boxAlign = 'center',
  rightComponent,
  textCenter = false,
  textColor,
}: InfoBoxProps) => {
  return (
    <Box
      bgColor={bgColor}
      padding={padding}
      testID={testID}
      radius={radius}
      margin={margin}
      flexRow={!!leftComponent}
      boxAlign={boxAlign}>
      {leftComponent && (
        <ColumnWithMargins mr={5}>{leftComponent}</ColumnWithMargins>
      )}
      {headline.length > 0 && (
        <Headline1 testID={`${testID}-headline`}>{headline}</Headline1>
      )}
      {text.length > 0 && (
        <View>
          <Meta center={textCenter} testID={`${testID}-text`} color={textColor}>
            {text}
          </Meta>
        </View>
      )}
      {children}
      {rightComponent && (
        <ColumnWithMargins ml={5}>{rightComponent}</ColumnWithMargins>
      )}
    </Box>
  );
};

export default InfoBox;
